document.addEventListener("DOMContentLoaded", () => {
    const tooltips = document.querySelectorAll(".tooltip-wrapper");

    tooltips.forEach((tooltipWrapper) => {

        if (!tooltipWrapper.classList.contains('initialized')) {
            tooltipWrapper.classList.add('initialized');

            const button = tooltipWrapper.querySelector(".tooltip-button");
            const tooltip = tooltipWrapper.querySelector(".tooltip-content");
            const closeButton = tooltip.querySelector(".tooltip-close");

            if (!button || !tooltip) return;

            const action = button.getAttribute("data-action") || "click";
            const canHover = theme.device.hasHover;
            const tooltipPlacement = tooltip.getAttribute("data-placement") || "top";

            const popperInstance = Popper.createPopper(button, tooltip, {
                placement: tooltipPlacement,
                modifiers: [
                    {
                        name: "offset",
                        options: {offset: [0, 12]},
                    },
                    {
                        name: "preventOverflow",
                        options: {boundary: "viewport", padding: 8},
                    },
                    {
                        name: "flip",
                        options: {fallbackPlacements: ["top", "bottom", "left", "right"]},
                    },
                ],
            });

            function showTooltip() {
                tooltip.setAttribute("data-show", "");
                popperInstance.update();
            }

            function hideTooltip() {
                tooltip.removeAttribute("data-show");
            }

            function toggleTooltip() {
                if (tooltip.hasAttribute("data-show")) {
                    hideTooltip();
                } else {
                    showTooltip();
                }
            }

            if (action === "hover" && canHover) {
                button.addEventListener("mouseenter", showTooltip);
                button.addEventListener("focus", showTooltip);
                button.addEventListener("mouseleave", hideTooltip);
                button.addEventListener("blur", hideTooltip);
                tooltip.classList.add('hide-close');
            } else {
                button.addEventListener("click", (event) => {
                    event.stopPropagation();
                    toggleTooltip();
                });

                document.addEventListener("click", (event) => {
                    if (!tooltipWrapper.contains(event.target)) {
                        hideTooltip();
                    }
                });
            }

            if (closeButton) {
                closeButton.addEventListener("click", hideTooltip);
            }
        }
    });
});